/* 定期BOXの選択画面（/apps/subscription/bundlerV2）の商品名を整える
   アプリが「商品名 - 商品名」と2回くり返して出すので1回にし、
   「（定期購入用）」を表示から外す。Shopify側の商品名は変えない。
   あわせて、BOX説明文の改行を保ち、説明文の中のURLを押せるリンクにする。 */
(function () {
  if (location.pathname.indexOf('/apps/subscription/') === -1) return;

  function clean(text) {
    var m = text.match(/^\s*(.+?) - \1\s*$/);
    var s = m ? m[1] : text;
    return s.replace(/\s*[（(]定期(購入|BOX)用[）)]/g, '');
  }

  function run(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('定期') === -1) continue;
      var v = clean(node.nodeValue);
      if (v !== node.nodeValue) node.nodeValue = v;
    }
  }

  // BOX説明文の中のURL（公式LINEなど）を、押せるリンクにする。
  // 説明文はアプリが文字としてそのまま出すため、HTMLを書いてもリンクにならない。
  function linkify(root) {
    var boxes = root.querySelectorAll('.huckleberry-box-setting-description');
    for (var i = 0; i < boxes.length; i++) {
      var walker = document.createTreeWalker(boxes[i], NodeFilter.SHOW_TEXT);
      var targets = [];
      var node;
      while ((node = walker.nextNode())) {
        if (node.parentNode.nodeName !== 'A' && /https?:\/\//.test(node.nodeValue)) targets.push(node);
      }
      targets.forEach(function (t) {
        var parts = t.nodeValue.split(/(https?:\/\/[^\s\u3000）)」]+)/);
        var frag = document.createDocumentFragment();
        parts.forEach(function (part, idx) {
          if (idx % 2) {
            var a = document.createElement('a');
            a.href = part;
            a.textContent = part;
            a.target = '_blank';
            a.rel = 'noopener';
            a.style.textDecoration = 'underline';
            frag.appendChild(a);
          } else if (part) {
            frag.appendChild(document.createTextNode(part));
          }
        });
        t.parentNode.replaceChild(frag, t);
      });
    }
  }

  function start() {
    // BOX説明文の改行を、入力したとおりに表示する
    var style = document.createElement('style');
    style.textContent = '.huckleberry-box-setting-description{white-space:pre-line}';
    document.head.appendChild(style);

    var root = document.getElementById('boxSettingContent') || document.querySelector('main');
    if (!root) return;
    run(root);
    linkify(document);
    new MutationObserver(function () { run(root); linkify(document); })
      .observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
